import { shallowMount } from "@vue/test-utils";
import DigitalKey from "@/components/core/DigitalKey";

describe("DigitalKey component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(DigitalKey);
  });

  it("Renders del component DigitalKey", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
